module.exports = __webpack_public_path__ + "media/images/icon_search_officename-dd1c6aaaf7c9c4ec6d5abe038a473575.png";